import styled from '@emotion/styled'

export const StyledContainer = styled.div`
  width: 100%;

  & > :not(:last-child) {
    margin-bottom: 24px;
  }
  input {
    background: white;
  }
`
